<template>
  <div>
    <viber-bot v-if="selectedPlatform === 'viber_bot'"></viber-bot>
    <viber-business v-else-if="selectedPlatform === 'viber_business'"></viber-business>
    <template v-else>
      <h4 class="text-center">Select Viber Platform</h4>
      <div class="mt-5 list-group">
        <router-link v-for="(platform, key) in viberPlatforms"
                     :key="key"
                     :to="{name: 'administration.channels.new', query: {platform: platform.type}}"
                     active-class="none"
                     class="list-group-item list-group-item-action p-4">
          <wizard-item :icon="platform.icon"
                       :title="platform.name"
                       :description="platform.description"></wizard-item>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
  import ViberBotWizard from './ViberBotWizard'
  import ViberBusinessWizard from './ViberBusinessWizard'
  import viberSVG from '@/assets/img/logo/channels/viber/viber_with_beak.svg'
  import WizardItem from '@/components/administration/common/WizardItem'

  export default {
    components: {
      ViberBot: ViberBotWizard,
      ViberBusiness: ViberBusinessWizard,
      WizardItem
    },

    data() {
      return {
        viberPlatforms: [
          {
            type: 'viber_bot',
            name: 'Viber Bot',
            icon: viberSVG,
            description: 'Viber Bot account allows you to create a public channel to which your customers can subscribe and communicate with your chatbot. Your customers have to initiate the conversation first.'
          },
          {
            type: 'viber_business',
            name: 'Viber Business Messages',
            icon: viberSVG,
            description: 'Viber Business Messages allows you to send messages to a phone number, offering lower prices and more features than SMS.'
          }
        ]
      }
    },

    computed: {
      selectedPlatform() {
        return this.$route.query.platform
      }
    }
  }
</script>
